import { useState } from 'react'
import { Box } from '@mui/system'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router'
import { useAuth } from '../../context/Auth/AuthContext'
import LoginForm from '../../components/LoginForm'
import { api } from '../../services/api'
import { deleteCookie, getCookie, setCookie } from '../../utils/auxFunc'
import './LoginContainer.css'

const LoginContainer = () => {
  const [user, setUser] = useState({
    userAccount: getCookie('monacoUserName') || '',
    userPassword: ''
  })
  const [isChecked, setIsChecked] = useState(
    Boolean(getCookie('monacoRememberUser'))
  )
  const navigate = useNavigate()
  const { signIn } = useAuth()

  const handleSubmit = (evt) => {
    evt.preventDefault()

    if (user.userAccount !== '' && user.userPassword !== '') {
      api.account
        .login(user.userAccount, user.userPassword)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          if (data?.status) {
            saveUserNameCookie('monacoUserName', user.userAccount)
            data.clientCity = data.clientCity.replace(/\d+/g, '').trim()
            data.clientAddress = data.clientAddress.replace(/\/+/g, '-')
            signIn(data)
            navigate('/')
          } else {
            Swal.fire({
              customClass: {
                confirmButton: 'swalBtnOk'
              },
              position: 'center',
              icon: 'error',
              title: 'Hubo un problema al iniciar sesión',
              text: data.message,
              showConfirmButton: true,
              focusConfirm: false,
              iconColor: '#FF8A65',
              color: '#FAFAFA',
              background: '#292929',
              confirmButtonColor: '#292929'
            })
          }
        })
        .catch((error) => console.error('Error - ', error))
    } else {
      ;(user.userAccount === '' || user.userPassword === '') &&
        Swal.fire({
          customClass: {
            confirmButton: 'swalBtnOk',
            title: 'swalTitle'
          },
          position: 'center',
          icon: 'warning',
          title: 'Complete todos los campos',
          width: '350px',
          showConfirmButton: true,
          focusConfirm: false,
          iconColor: '#FF8A65',
          color: '#FAFAFA',
          background: '#292929',
          confirmButtonColor: '#292929'
        })
    }
  }

  const handleChange = (evt) => {
    setUser({ ...user, [evt.target.name]: evt.target.value })
  }

  const saveUserNameCookie = (cookieName, cookieValue) => {
    if (!isChecked) {
      deleteCookie(cookieName)
      return
    }

    setCookie(cookieName, cookieValue, 365)
  }

  const handleChecked = (evt) => {
    setIsChecked(evt.target.checked)

    if (!evt.target.checked) {
      deleteCookie('monacoUserName')
      deleteCookie('monacoRememberUser')
      return
    }

    setCookie('monacoRememberUser', evt.target.checked, 365)
  }

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) => {
          return theme.palette.primary.main
        },
        width: '100vw',
        heigth: '100vh'
      }}
    >
      <LoginForm
        user={user}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        isChecked={isChecked}
        handleChecked={handleChecked}
      />
    </Box>
  )
}

export default LoginContainer
